import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { StepProps } from "./CreateCampaignWizard";
import { Navigation } from "./Navigation";
import AdsetImage from "./AdsetImage";

const AdsetHome = ({ adset, back,steps, next, navigateTo }: StepProps) => {
  const hasAdset = !!adset;
  const isCreateCampaign = steps.at(0) === "create_campaign";
  return (
    <VStack w="full" alignItems={"flex-start"} gap={4}>
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Text
          fontSize={"lg"}
          textTransform={"uppercase"}
          fontWeight={"bold"}
          color={"gray.400"}
        >
          Adset
        </Text>
        {hasAdset ? (
          <Text fontWeight={"bold"} fontSize={"lg"}>
            {adset?.name}
          </Text>
        ) : null}
      </HStack>
      <HStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        {adset?.ads?.length ? (
          adset?.ads?.map((ad) => (
            <VStack
              flexGrow={0}
              flexWrap={"wrap"}
              flexShrink={0}
              maxW={"200px"}
            >
              <AdsetImage
                adset={{ ads: [ad] }}
                imageProps={{
                  aspectRatio: "1/1",
                  maxW: "200px",
                  minW: "200px",
                  width: undefined,
                  height: undefined,
                  borderRadius: "md",
                  objectFit: "cover",
                  shadow: "md",
                  border: "1px solid",
                  borderColor: "gray.200",
                }}
              />
              <Text
                fontWeight={"bold"}
                textAlign={"left"}
                w="full"
                maxW={["full", "400px"]}
              >
                {ad?.name}
              </Text>
              <Text w="full" textAlign={"left"} fontSize="sm">
                {ad?.creative?.message}
              </Text>
            </VStack>
          ))
        ) : hasAdset ? (
          <VStack>
            <Text>No creatives yet!</Text>
          </VStack>
        ) : null}
      </HStack>

      <HStack w="full">
        <Box
          background={"gray.100"}
          w="full"
          aspectRatio="2/1"
          borderRadius={"md"}
          p={4}
          alignItems={"center"}
          justifyContent={"center"}
          display={"flex"}
          onClick={() => hasAdset ? navigateTo("edit_adset") : navigateTo("create_adset")}
        >
          <VStack w="full" gap={16}>
            <Text fontWeight={"bold"} fontSize={"lg"}>
              {hasAdset ? "Edit adset" : "Create adset"}
            </Text>
            <Text fontSize={"sm"}>
              Includes budget, targeting configuration, schedule, and more.
            </Text>
          </VStack>
        </Box>
        <Box
          background={"gray.100"}
          opacity={!hasAdset ? 0.5 : 1}
          pointerEvents={!hasAdset ? "none" : "auto"}

          borderRadius={"md"}
          w="full"
          aspectRatio="2/1"
          p={4}
          onClick={() => navigateTo("list_ads")}
          flexWrap={"wrap"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <VStack w="full" flexWrap={"wrap"} gap={16}>
            <Text fontWeight={"bold"} fontSize={"lg"}>
              {hasAdset ? "Edit creatives" : "You need to create the adset first 👈"}
            </Text>
            <Text fontSize={"sm"}>
              Includes budget, targeting configuration, schedule, and more.
            </Text>
          </VStack>
        </Box>
      </HStack>
      <Navigation back={back} next={isCreateCampaign ? next : null} canNext={isCreateCampaign} />
    </VStack>
  );
};

export default AdsetHome;
